<template>
  <div>
    <div v-if="hasProducts" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
      <product-card-item
        v-for="(product, i) in products"
        :key="`${settings.locationId}${product.code}`"
        :item-id="`${i}`"
        :is-compare-button-enabled="isCompareButtonEnabled"
        :product="product"
      />
    </div>
  </div>
</template>
<script>
import ProductsList from './mixins/products-list';
import ProductCardItem from './ProductCardItem';

export default {
  components: {
    ProductCardItem,
  },
  mixins: [ProductsList],
};
</script>
